export default "__VITE_ASSET__D$odnd6q__"